<template>
  <v-dialog v-model="dialog" persistent max-width="1000">
    <template v-slot:activator="{ on }">
      <v-btn v-on="on" outlined :color="color" class="ml-3">
        <v-icon>{{ icon }}</v-icon
        ><span v-if="edit === false">Adicionar</span>
      </v-btn>
    </template>
    <v-card>
      <v-card-title class="modal-header elevation-10">
        <v-row>
          <v-col>
            <slot name="title"></slot>
          </v-col>
          <v-col class="text-right">
            <v-icon @click="dialog = false" color="white"
              >mdi-window-close</v-icon
            >
          </v-col>
        </v-row>
      </v-card-title>
      <v-card-text>
        <br /><br />
        <v-form ref="form">
          <v-row>
            <v-col sm="3">
              <v-text-field
                label="Número *"
                name="numero"
                type="number"
                :rules="[rules.required]"
                v-model="payload.numero"
              ></v-text-field>
            </v-col>

            <v-col sm="3">
              <v-text-field
                label="Pontos *"
                name="Pontos"
                type="number"
                :rules="[rules.required]"
                v-model="payload.pontos"
              ></v-text-field>
            </v-col>
            <v-col sm="2" v-if="isFullAdmin">
              <v-checkbox
                v-model="payload.nacional"
                label="Nacional"
                color="primary"
              >
              </v-checkbox>
            </v-col>
            <v-col sm="4">
              <v-checkbox
                v-model="payload.possuiComentario"
                label="Poderá possuir comentário?"
                color="primary"
              >
              </v-checkbox>
            </v-col>

            <v-col sm="4">
              <v-textarea
                label="Texto *"
                name="texto"
                type="text"
                :rules="[rules.required]"
                v-model="payload.texto"
              ></v-textarea>
            </v-col>
            <v-col sm="4">
              <v-textarea
                label="Indicador Texto"
                name="texto *"
                type="text"
                :rules="[rules.required]"
                v-model="payload.indicadorTexto"
              ></v-textarea>
            </v-col>
            <v-col sm="12">
              <v-label> Evidência</v-label>
              <vue-editor
                v-if="isSala"
                v-model="payload.evidencia"
                label="Evidencia"
                name="evidencia"
              />
              <v-textarea
                v-else
                label="Evidencia"
                name="evidencia"
                type="text"
                v-model="payload.evidencia"
              ></v-textarea>
            </v-col>
          </v-row>
        </v-form>
        <v-row>
          <v-col cols="6">
            <app-temas-combobox :filter="payload" ref="temas">
            </app-temas-combobox>
          </v-col>
          <v-col cols="6">
            <combo-get-projeto-by-uf
              :filter="payload"
              :label="'*Não exibir para projetos'"
            ></combo-get-projeto-by-uf>
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions>
        <div class="flex-grow-1"></div>
        <v-btn color="error" outlined text @click="dialog = false"
          >Fechar</v-btn
        >
        <v-btn color="info" outlined text @click="onConfirm">Salvar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import { perguntaAPI } from "../API/Pergunta";
import { mapActions, mapGetters } from "vuex";
import AppTemasCombobox from "./Combobox.vue";
import ComboGetProjetoByUf from "../../project/components/ComboGetProjetoByUf.vue";
import { VueEditor } from "vue2-editor";
export default {
  name: "AppModalInsert",
  props: {
    object: { type: Object, required: false },
    edit: { type: Boolean, required: false, default: false },
    icon: { type: String, required: true },
    color: { type: String, required: true },
  },
  components: {
    AppTemasCombobox,
    ComboGetProjetoByUf,
    VueEditor,
  },
  data() {
    return {
      payload: { projectId: [] },
      dialog: false,
      rules: {
        required: (value) => !!value || "Campo Obrigatório",
      },
      selectValidate: false,
    };
  },
  mounted() {
    if (this.object && this.edit === true) {
      this.payload = { ...this.object };
      console.log("this.payload.numero: ", this.payload.numero);
      console.log(
        "this.payload.ocultarParaProjetos: ",
        this.payload.ocultarParaProjetos
      );

      if (
        !this.payload.ocultarParaProjetos ||
        this.payload.ocultarParaProjetos == "[]"
      )
        this.payload.projectId = [];
      else
        this.payload.projectId = this.payload.ocultarParaProjetos
          .split(",")
          .map((item) => parseInt(item));
    } else {
      this.loadUltimaPergunta();
    }
  },
  computed: {
    ...mapGetters(["isAdmin", "isFullAdmin", "isSala"]),
  },
  methods: {
    ...mapActions(["setLoading"]),
    saveSelect(e) {
      this.selectValidate = e;
    },
    loadUltimaPergunta() {
      perguntaAPI.getUltimaPergunta().then(({ data }) => {
        this.payload.numero = data.numero;
        this.payload.perguntaAnteriorSim = data.perguntaAnteriorSim;
        this.payload.perguntaSeguinteSim = data.perguntaSeguinteSim;
        this.payload.perguntaAnteriorNao = data.perguntaAnteriorNao;
        this.payload.perguntaSeguinteNao = data.perguntaSeguinteNao;
      });
    },
    onConfirm() {
      let temaValidate = this.$refs.temas.validate();
      if (this.$refs.form.validate() && temaValidate) {
        this.payload.selo = "Bronze";
        this.payload.nivel = 1;
        this.payload.grupo = 0;
        this.payload.indicadorResposta = "Sim";
        this.payload.master = 1;
        this.payload.somenteAcompanhamento = 0;
        this.payload.recorrente = 0;
        if (this.payload.projectId && this.payload.projectId.length > 0)
          this.payload.ocultarParaProjetos = this.payload.projectId.join(",");
        else this.payload.ocultarParaProjetos = "";
        if (this.payload.indicadorTexto === null) {
          this.payload.indicadorTexto = this.payload.texto;
        }
        if (this.edit === true) {
          this.setLoading(true);
          perguntaAPI
            .update(this.payload)
            .then(() => {
              this.dialog = false;
              this.$emit("on-save");
              location.reload();
              this.setLoading(false);
            })
            .catch(() => {
              this.setLoading(false);
            });
        } else {
          this.setLoading(true);
          perguntaAPI
            .create(this.payload)
            .then(() => {
              this.dialog = false;
              this.$emit("on-save");
              location.reload();
              this.setLoading(false);
            })
            .catch(() => {
              this.setLoading(false);
            });
        }
      }
    },
  },
};
</script>

